import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByMultipleKeys'
})
export class FilterByMultipleKeysPipe implements PipeTransform {

  public transform(value: any[], keys: string, term: string): any[] {
    if (!term || !value) return value;

    const splitKeys = keys.split(',');

    // Convert the term to lowercase for case-insensitive search
    term = term.toLowerCase();

    return value.filter(item => {
        return splitKeys.some(key => {
            const keyParts = key.split('.');
            let tempObject = item;

            // Traverse through nested properties if needed
            for (const part of keyParts) {
                if (tempObject && tempObject.hasOwnProperty(part)) {
                    tempObject = tempObject[part];
                } else {
                    return false;
                }
            }

            // Check if the field contains the search term (case-insensitive)
            return tempObject && tempObject.toString().toLowerCase().includes(term);
        });
    });
}

}
